import React, { useContext, useEffect, useState } from 'react';

import { Container as MaterialContainer } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';
import * as customColumnsSelectors from 'common/modules/customColumnsV2/selectors';
import { LoadingContext } from 'common/utils/contexts';

import * as funnelFinancingActions from '../funnelFinancing/actions';
import * as funnelFinancingSelectors from '../funnelFinancing/selectors';

import * as actions from './actions';
import ListItems from './components/ListItems';
import * as selectors from './selectors';

const Container = ({
    companies,
    downloadFile,
    fetchCompanies,
    fetchRates,
    filterQuotes,
    isDownloading,
    isFetching,
    isFetchingCompanies,
    isFetchingRates,
    isFetchingTableSettings,
    paginationItems,
    quotes,
    rates,
    tableSettings,
}) => {
    const { t } = useTranslation();
    const loadingContext = useContext(LoadingContext);
    const [filterData, setFilterData] = useState({
        company: '',
        orderBy: 'created_at',
        page: 0,
        pageSize: 25,
        rateName: 'all',
        searchText: '',
        sortBy: 'desc',
        status: 'active',
    });
    useEffect(() => {
        fetchCompanies();
        fetchRates();
        filterQuotes(filterData);
    }, []);

    useEffect(() => {
        if (isEmpty(loadingContext)) return;
        if (isDownloading) loadingContext.openLoading(t('Downloading'));
        else loadingContext.closeLoading();
    }, [isDownloading]);

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <TitleIcon title={t('Quote_other')} />
            </HeaderContainer>

            <ListItems
                companies={companies}
                downloadFile={downloadFile}
                filterData={filterData}
                filterItems={filterQuotes}
                isFetching={
                    isFetching ||
                    isFetchingCompanies ||
                    isFetchingRates ||
                    isFetchingTableSettings
                }
                items={quotes}
                paginationData={paginationItems}
                rates={rates}
                setFilterData={setFilterData}
                tableSettings={tableSettings}
            />
        </MaterialContainer>
    );
};

Container.propTypes = {
    companies: PropTypes.array,
    downloadFile: PropTypes.func,
    fetchCompanies: PropTypes.func,
    fetchRates: PropTypes.func,
    filterQuotes: PropTypes.func,
    isDownloading: PropTypes.bool,
    isFetching: PropTypes.bool,
    isFetchingCompanies: PropTypes.bool,
    isFetchingRates: PropTypes.bool,
    isFetchingTableSettings: PropTypes.bool,
    paginationItems: PropTypes.object,
    quotes: PropTypes.array,
    rates: PropTypes.array,
    tableSettings: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    companies: funnelFinancingSelectors.getCompaniesData,
    isDownloading: selectors.getIsDownloading,
    isFetching: selectors.getIsFetchingQuotes,
    isFetchingCompanies: funnelFinancingSelectors.getCompaniesIsFetching,
    isFetchingRates: selectors.getIsFetchingRates,
    isFetchingTableSettings: customColumnsSelectors.getIsFetchingTableSettings,
    paginationItems: selectors.getQuotesPagination,
    quotes: selectors.getQuotesData,
    rates: selectors.getRatesData,
    tableSettings: customColumnsSelectors.getTableSettingsData,
});

const mapDispatchToProps = (dispatch) => ({
    downloadFile: (filterData) => dispatch(actions.downloadFile(filterData)),
    fetchCompanies: () => dispatch(funnelFinancingActions.fetchCompanies()),
    fetchRates: () => dispatch(actions.fetchRates()),
    filterQuotes: (filterData) => dispatch(actions.filterQuotes(filterData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
